import { Controller } from "@hotwired/stimulus";

/**
 * Day Assignment Toggle Controller
 *
 * Shows/hides day checkboxes based on the "All Days" / "Specific Days" select.
 * Used in invitee rows, invitation forms, and registration day assignment dialogs.
 */
export class DayAssignmentToggleController extends Controller {
  static targets = ["select", "days"];

  connect() {
    this.setVisibility();
  }

  setVisibility() {
    const show = this.selectTarget.value === "specific_days";
    this.daysTargets.forEach((el) => {
      el.hidden = !show;
    });
  }
}
